import { useTranslation } from 'react-i18next';
import { IssueTicketPreview, IssueTicketsPreviewItem } from './item';
import { Button } from '@otp/ui';

type IssueTicketsPreviewListProps = {
  issueTickets: IssueTicketPreview[];
  onAddAnotherIssue: () => void;
};

export const IssueTicketsPreviewList = ({
  issueTickets,
  onAddAnotherIssue,
}: IssueTicketsPreviewListProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'wttp.question-response.status',
  });

  if (!issueTickets.length) {
    return null;
  }

  return (
    <div className="mb-6">
      <div>
        {issueTickets.map((ticket) => (
          <IssueTicketsPreviewItem key={ticket.id} ticket={ticket} />
        ))}
      </div>
      <Button className="float-right" onClick={onAddAnotherIssue}>
        {t('add-another-issue')}
      </Button>
    </div>
  );
};
